import { useEffect, useRef, useState } from 'react';
import { TileLayer, MapContainer, MapConsumer } from 'react-leaflet';
import { LatLngBounds } from 'leaflet';
import MarkerClusterGroup from "react-leaflet-markercluster";
import ItemMarker from './item-marker';
import { subscribeData } from '../services/data-service';

import './carte.scss';
import '../../node_modules/leaflet/dist/leaflet.css';
import '../../node_modules/react-leaflet-markercluster/dist/styles.min.css';

const maxBounds = new LatLngBounds([45.29421101337773, 4.998779296875001], [41.828642001860544, -0.5053710937500001]);

const Carte = ({ params }) => {

    const clusterRef = useRef();
    const [mapData, setMapData] = useState([]);

    useEffect(() => {

        const onData = (newData) => {
            if(!newData) return;
            // const nextData = newData.map(item => {
            //     return {...item, location: JSON.parse(item.location) }
            // });
            setMapData([...newData]);
        }

        const unsubscribe = subscribeData(onData);

        return function cleanup() {
            unsubscribe(onData);
        }

    }, []);

    const selected = mapData.find(item => item.selected);

    return (
        <div className="data-map-carte">
            <MapContainer center={params.center} zoom={params.zoom} style={{height: '100%'}} scrollWheelZoom={false}>
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" 
                    attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
                />
                <MarkerClusterGroup ref={clusterRef} showCoverageOnHover={false}>
                    {mapData.map(item => <ItemMarker key={`${item.idgis}-${item.id}`} data={item} location={item.location} parent={clusterRef.current} selected={item.selected} />)}
                </MarkerClusterGroup>
                <MapConsumer>
                    {(map) => {
                        if(!selected){
                            setTimeout(() => {
                                if(clusterRef.current){
                                    map.fitBounds(maxBounds, {padding: [40,40]});
                                }
                            }, 300);
                        }
                        return null;
                    }}
                </MapConsumer>
            </MapContainer>
        </div>
    );
};

export default Carte;